import { FormElementState } from './form-element-state';
import { FormElementError } from './form-element-error';

export class FormElementValidators {
  static defaultValidator(value: any, state: FormElementState, error: FormElementError) {
    if (state) {
      if (state.mandatory) {
        if (!value || value.toString().trim() == '') {
          error.required = true;
        }
      }
    }
  }

  static stringValidator(value: string, state: FormElementState, error: FormElementError) {
    if (state) {
      if (state.mandatory) {
        if (!value || value.trim().length == 0) {
          error.required = true;
        }
      }
    }
  }

  static numericValidator(value: string, state: FormElementState, error: FormElementError) {
    if (state) {
      if (state.mandatory) {
        if (!value || value.toString().trim().length == 0) {
          error.required = true;
        }
      }
    }

    if (!error.required) {
      if (!value || value.toString().trim().length == 0) {
        error.invalid = true;
      } else {
        error.invalid = !FormElementValidators.isIntegerNumeric(value);
      }
    }
  }

  // private static isNumeric(value): boolean {
  //   return /^\d+$/.test(value);
  // }

  private static isIntegerNumeric(value): boolean {
    return /^\d+$/.test(value);
  }

  private static isFloatNumeric(value): boolean {
    return /([0-9]*[.])?[0-9]+/.test(value);
  }


  static stringMaxLengthValidator(value: string, state: FormElementState, error: FormElementError, validationRules: any) {
    if (state) {
      if (state.mandatory) {
        if (!value || value.trim().length == 0) {
          error.required = true;
        }
      }

      if (validationRules) {
        if (value) {
          if (value.trim().length > validationRules.maxLength) {
            error.invalid = true;
            error.maxlength = true;
            //pošto se ova poruka nigde ne koristi uklanjam je
            //  error.message = `Максимална дужина вредности мора бити ${validationRules.maxLength} карактера`;
          }
        }
      }
    }
  }

  static integerValidator(value: string, state: FormElementState, error: FormElementError) {

    if (state) {
      if (state.mandatory) {
        error.required = false;
        error.invalid = false;

        if (value === null) {
          error.required = true;
          error.invalid = false;
        }
        else {
          if (!FormElementValidators.isIntegerNumeric(value)) {
            error.required = false;
            error.invalid = true;
          }
        }
      }
      else {
        if (value != null) {
          if (!FormElementValidators.isIntegerNumeric(value)) {
            error.required = false;
            error.invalid = true;
          }
        }

      }
    }

  }

  static floatValidator(value: string, state: FormElementState, error: FormElementError) {

    if (state) {
      if (state.mandatory) {
        error.required = false;
        error.invalid = false;

        if (value === null) {
          error.required = true;
          error.invalid = false;
        }
        else {
          if (!FormElementValidators.isFloatNumeric(value)) {
            error.required = false;
            error.invalid = true;
          }
        }
      }
      else {
        if (value != null) {
          if (!FormElementValidators.isFloatNumeric(value)) {
            error.required = false;
            error.invalid = true;
          }
        }

      }
    }

  }


}
